import React, { useState, useEffect } from "react"
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './blog.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { blog, blogTopic } from "../../api/blog"
import { getImageUrl } from "../../utils/imageUrl"
// -------------------------------------------------

const Blog = () => {
  const navigate = useNavigate()

  const [blogData, setBlogData] = useState([])

  const [paginationData, setPaginationData] = useState([])

  const getBlogs = async () => {
    const { data } = await blog()
    setBlogData(data?.docs)
    setPaginationData({
      total: data.totalDocs,
      pageCount: data.totalPages,
      currentPage: data.page,
    })
  }
  useEffect(() => {
    getBlogs()
  }, [])

  const [topic, setTopic] = useState([])

  const topics = async () => {
    const resp = await blogTopic()
    setTopic(resp.data)
  }
  useEffect(() => {
    topics()
  }, [])

  return (
    <>
      <Header />
      <section className='specialOffers blogSection'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Latest Blogs & News</h4>
            </div>
          </div>
          <div className="row blogs">
            <div className="col-md-9 cardSec">
              <div className="row g-4 g-xl-5">
                {blogData?.map((items) => (
                  <div key={items?._id} className="col-md-6 cardSec">
                    <div className="card bg-transparent">
                      <div className="row align-items-center">
                        <div className="col-sm-5">
                          <img src={getImageUrl(items?.images?.[0])} className="card-img" alt="" />
                        </div>
                        <div className="col-sm-7">
                          <div className="card-body p-sm-0">
                            <h5 className="card-title">{items?.title}</h5>
                            <p className="mb-0">{items?.topics?.map((item) => item)}</p>
                            <Button
                              className="btnDetail"
                              onClick={() => {
                                navigate(`/blogDetail/${items?._id}`)
                              }}
                            >
                              View Detail
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}


              </div>
            </div>
            <div className="col-md-3">
              <div className="categoriesSec">
                <h4 className="mb-0 title">Topics</h4>
                <ul>
                  {topic?.map((item) => (
                    <li
                      onClick={async () => {
                        const { data } = await blog({ topics: [item?.name] })
                        setBlogData(data?.docs)
                        setPaginationData({
                          total: data.totalDocs,
                          pageCount: data.totalPages,
                          currentPage: data.page,
                        })
                      }}
                      key={item?._id}>{item?.name}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          {paginationData.pageCount > 1 && (
            <Stack
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: '40px 0 10px 0'
              }}
              spacing={2}
            >
              <Pagination
                count={paginationData.pageCount || 1}
                onChange={async (e, page) => {
                  const { data } = await blog({

                    skip: (page - 1)
                  })
                  setBlogData(data.docs)
                }}
                color="secondary" />
            </Stack>)}
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Blog
